<template>
  <form-item
    v-if="isForm"
    :name="name"
    :rules="rules"
    :hasLabel="hasLabel"
    :label="label"
    :hasDesc="hasDesc"
    :prop="prop"
    :descContent="getTransText(name,'desc',base)"
    >
    <el-cascader
      v-model="val"
      class="form-item"
      separator=" - "
      :props="props"
      :placeholder="getTransText(name,'remoteHolder',base)"
      @input="onInput"
      filterable
      ref="selector"
      >
    </el-cascader>
  </form-item>
  <el-table-column
    v-else
    v-bind="$attrs"
    :label="labelText"
    align="center"
    >
    <template slot-scope="scope">
      <item-link
        v-if="scope.row.blog_country_id"
        base="blogCountry"
        basePath="/web/blog/blog_country"
        idField="blog_country_id"
        nameField="blog_country_name"
        :rowData="scope.row"
        type="primary"
        >
      </item-link>
      <div
        v-else-if="scope.row.category_id && scope.row.country_id"
        >
        <item-link
          base="blogCountry"
          basePath="/web/blog/blog_country"
          idField="country_id"
          nameField="country_name"
          :rowData="scope.row"
          type="primary"
          >
        </item-link>
        -
        <item-link
          base="blogCategory"
          basePath="/web/blog/blog_category"
          idField="category_id"
          nameField="category_name"
          :rowData="scope.row"
          type="primary"
          >
        </item-link>
      </div>
    </template>
  </el-table-column>
</template>

<script>

import { getTransText } from '@/utils/i18n'
import { fetchList as fetchCountryList } from '@/api/web/blog_country'
import { fetchList as fetchCategoryList } from '@/api/web/blog_category'

export default {
  name: 'blog-category',
  props: {
    value: null,
    name: {
      type: String,
      default: ''
    },
    base: {
      type: String,
      default: ''
    },
    isForm: {
      type: Boolean,
      default: false
    },
    hasLabel: {
      type: Boolean,
      default: true
    },
    hasDesc: {
      type: Boolean,
      default: false
    },
    labelText: {
      type: String,
      default: ''
    },
    prop: {
      type: String
    }
  },
  data () {
    return {
      val: this.value,
      props: {
        lazy: true,
        lazyLoad (node, resolve) {
          if (node.level === 0) {
            fetchCountryList({
              page: 1,
              limit: 1000,
              sort: 'status,rank,id'
            }).then(res => {
              const nodes = Array.from(res.data)
                .map(item => ({
                  value: item.id,
                  label: item.name,
                  leaf: false
                }))
              resolve(nodes)
            }).catch(error => {
              console.log(error)
            })
          } else {
            fetchCategoryList({
              page: 1,
              limit: 1000,
              sort: 'rank,id',
              filter: `{blog_country_id:${node.data.value}}`
            }).then(res => {
              const nodes = Array.from(res.data)
                .map(item => ({
                  value: item.id,
                  label: item.name,
                  leaf: true
                }))
              resolve(nodes)
            }).catch(error => {
              console.log(error)
            })
          }
        }
      }
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {
    rules () {
      return [{
        required: true,
        validator: (rule, value, callback) => {
          if (!this.val || this.val.length <= 0) {
            callback(new Error(this.getTransText(this.name, 'error', this.base)))
          } else {
            callback()
          }
        },
        trigger: 'blur'
      }]
    },
    label () {
      return this.labelText || this.getTransText(this.name, 'label', this.base)
    }
  },
  methods: {
    getTransText,
    onInput () {
      this.$emit('input', this.val)
    }
  },
  watch: {
    value (newValue) {
      this.val = newValue
    }
  }
}
</script>
